import { roomBookingDetailsPath } from './roomBookingDetailsPath';
import { tutorBookingDetailsPath } from './tutorBookingDetailsPath';

/**
 * `/host/requests?bookingId=` is used by room-booking SMS and (historically) tutor-booking SMS.
 * Resolve the details page after probing GET /v1/host/room-bookings/{id}.
 */
export function hostRequestsQueryBookingTarget(
  bookingId: string,
  roomLookupHttpStatus: number | null,
): string | null {
  const id = bookingId.trim();
  if (!id) return null;
  if (roomLookupHttpStatus === 200) {
    return roomBookingDetailsPath('host', id);
  }
  if (roomLookupHttpStatus === 404) {
    return tutorBookingDetailsPath('host', id);
  }
  return null;
}
